import { useMemo, useState } from "react";
import { sortItems } from "@sscs/utils";
/**
 * Sort an array of objects.
 * @param items Objects to sort
 * @param initProperty Initial sort key
 * @param initReverse Sort in reverse
 * @param specialCases Custom sort functions per key. Must be stable across renders — it is a hook dependency.
 */
function useSort(items, initProperty, initReverse, specialCases) {
    const [sortBy, setSortBy] = useState({
        property: initProperty,
        reverse: initReverse,
    });
    const sortedItems = useMemo(() => {
        return sortItems(items, sortBy, specialCases);
    }, [items, sortBy, specialCases]);
    return [sortBy, setSortBy, sortedItems];
}
export default useSort;
//# sourceMappingURL=useSort.js.map